import stringify from 'json-stringify-safe';
import { RequestBuilder } from '@cvent/nucleus-networking';
import debounce from 'lodash.debounce';

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var https = 'https://';
var encodedHttps = encodeURIComponent(https);
var regExpHttps = new RegExp(https, 'g');
/**
 * To prepare the messages we do the two following things. Stringify safely to account
 * for any accidental circular references and replace instances of https:// to an
 * encoded version to prevent tripping WAF (Web Access Firewall) violations.
 */

var prepareMessagesForTransport = function prepareMessagesForTransport(messages) {
  return stringify(messages).replace(regExpHttps, encodedHttps);
};

var BaseRemoteLogClient = /*#__PURE__*/function () {
  function BaseRemoteLogClient(config) {
    _classCallCheck(this, BaseRemoteLogClient);

    var _config$context = config.context,
        context = _config$context === void 0 ? {} : _config$context,
        _config$maxWaitMs = config.maxWaitMs,
        maxWaitMs = _config$maxWaitMs === void 0 ? 5000 : _config$maxWaitMs,
        _config$maxMessagesPe = config.maxMessagesPerInterval,
        maxMessagesPerInterval = _config$maxMessagesPe === void 0 ? 200 : _config$maxMessagesPe,
        modifyRequestBuilder = config.modifyRequestBuilder,
        _config$requestBuilde = config.requestBuilder,
        requestBuilder = _config$requestBuilde === void 0 ? new RequestBuilder({
      url: config.url,
      cache: 'no-cache',
      mode: 'cors'
    }).post().withCookies() : _config$requestBuilde;
    this.config = config;
    this.context = context;
    this.requestBuilder = requestBuilder;
    this.modifyRequestBuilder = modifyRequestBuilder;
    this.maxMessagesPerInterval = maxMessagesPerInterval;
    this.messages = [];
    this.maxWaitMs = maxWaitMs;
    this.flushNow = this.flushMessagesToServer;
    this.flushMessagesToServer = debounce(this.flushMessagesToServer, maxWaitMs, {
      maxWait: maxWaitMs,
      leading: true
    });
    /** Log requests that are yet to be sent to the server Array<Promise<mixed>> */

    this.pendingLogRequests = [];
  }

  _createClass(BaseRemoteLogClient, [{
    key: "debug",
    value: function debug() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.logMessage.apply(this, ['debug', this.context].concat(args));
    }
  }, {
    key: "info",
    value: function info() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      this.logMessage.apply(this, ['info', this.context].concat(args));
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      this.logMessage.apply(this, ['warn', this.context].concat(args));
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      this.logMessage.apply(this, ['error', this.context].concat(args));
    }
    /**
     * Creates a log message. Must be implemented by child class.
     * @param {('debug' | 'info' | 'warn' | 'error')} logLevel - level string
     * @param {Object} context - the context
     * @param {String} marker - marker string
     * @param {String} message - message
     * @param  {...any} args - remaining args as an array
     */
    // eslint-disable-next-line no-unused-vars

  }, {
    key: "createMessage",
    value: function createMessage(logLevel, context, marker, message) {
      throw new Error('Please implement createMessage');
    }
    /**
     * Log a message.
     * @param {('debug' | 'info' | 'warn' | 'error')} logLevel - level string
     * @param {Object} context - the context
     * @param {String} marker - marker string
     * @param {String} message - message
     * @param  {...any} args - remaining args as an array
     */

  }, {
    key: "logMessage",
    value: function logMessage(logLevel, context, marker, message) {
      if (this.messages.length >= this.maxMessagesPerInterval) {
        var max = this.maxMessagesPerInterval;
        var wait = this.maxWaitMs;
        this.messages[this.maxMessagesPerInterval - 1] = {
          logLevel: 'warn',
          marker: 'RemoteLogClient',
          message: "[".concat(marker, "]: exceeded max number of log messages ").concat(max, " per ").concat(wait, " (MS)")
        };
      } else {
        for (var _len5 = arguments.length, args = new Array(_len5 > 4 ? _len5 - 4 : 0), _key5 = 4; _key5 < _len5; _key5++) {
          args[_key5 - 4] = arguments[_key5];
        }

        this.messages.push(this.createMessage.apply(this, [logLevel, context, marker, message].concat(args)));
      }

      this.flushMessagesToServer();
    } // flush pending messages to the server, this method is throttled
    // see constructor.

  }, {
    key: "flushMessagesToServer",
    value: function flushMessagesToServer() {
      var _this = this;

      if (!this.messages.length) {
        // if a call to flushNow happened after the last call to this method
        // then the debouncing could result in an empty array
        return Promise.all(this.pendingLogRequests);
      } // if modifyRequestBuilder function is passed in, execute it before building the request


      if (this.modifyRequestBuilder) {
        this.requestBuilder = this.modifyRequestBuilder(this.requestBuilder);
      }

      var request = this.requestBuilder.body(prepareMessagesForTransport(this.messages)).header('Content-Type', 'application/json').build();
      var payload = this.messages.slice(0, this.messages.length);
      var count = this.messages.length;
      this.messages.length = 0;
      var pendingLogRequest = fetch(request).then(function (response) {
        _this.pendingLogRequests = _this.pendingLogRequests.filter(function (item) {
          return item !== pendingLogRequest;
        });

        if (!response.ok) {
          // Don't try to remote log new messages if the original request returned 404/401
          if (response.status !== 404 && response.status !== 401) {
            _this.error('RemoteLogClient', "failed to log ".concat(payload.length, " messages remotely to ").concat(_this.config.url, " status code ").concat(response.status, ", if configured each message will reported as an error to new relic"));

            if (typeof window !== 'undefined') {
              var _window$newrelic;

              if ((_window$newrelic = window.newrelic) !== null && _window$newrelic !== void 0 && _window$newrelic.noticeError) {
                payload.forEach(function (msg) {
                  return window.newrelic.noticeError(new Error("Failed to log remotely ".concat(JSON.stringify(msg))));
                });
              } else {
                // fallback to local console if no new relic and log endpoint is failing.
                // eslint-disable-next-line no-console
                payload.forEach(function (msg) {
                  return console.log(msg);
                });
              }
            }
          }
        }
      }).catch(function (e) {
        _this.pendingLogRequests = _this.pendingLogRequests.filter(function (item) {
          return item !== pendingLogRequest;
        });
        var errorMessage = e & e.message ? e.message : e;

        _this.error('RemoteLogClient', 'failed to log messages %d  %s', count, errorMessage);
      });
      this.pendingLogRequests.push(pendingLogRequest);
      return pendingLogRequest;
    }
  }]);

  return BaseRemoteLogClient;
}();

/**
 * By default, errors serialize to "{}" because all of their properties are non-enumerable. Work around this by copying
 * the non-enumerable properties on the error and its prototypes to another object where they will be enumerable.
 */
function formatError(err) {
  var result = {};
  var current = err;

  while (current && Object.getPrototypeOf(current) !== Object.prototype) {
    Object.getOwnPropertyNames(current).forEach(function (key) {
      if (typeof err[key] !== 'function') {
        result[key] = err[key];
      }
    });
    current = Object.getPrototypeOf(current);
  }

  return result;
}
var isError = function isError(value) {
  return value instanceof Error;
};

function formatIndividualArg(arg) {
  if (isError(arg)) {
    return stringify(formatError(arg));
  } else if (_typeof(arg) === 'object') {
    return stringify(arg);
  }

  return arg;
}
/**
 * Formats message to send to server
 * @param {String} marker - marker to be added before the log message
 * @param {String} message - the log message
 * @param {Array} args - other arguments to be added
 * @param {Object} context - the context the log message is associated with
 */


function formatMessage(marker, message, args, context) {
  return ["[".concat(marker, "]: ").concat(message)].concat(_toConsumableArray(args.map(function (a) {
    return formatIndividualArg(a);
  })), [formatIndividualArg(context), window && window.location ? window.location.toString() : 'no-location']).reduce(function (msg, token) {
    return "".concat(msg, " ").concat(token);
  });
}

var RemoteLogClient = /*#__PURE__*/function (_BaseRemoteLogClient) {
  _inherits(RemoteLogClient, _BaseRemoteLogClient);

  var _super = _createSuper(RemoteLogClient);

  function RemoteLogClient(config) {
    var _this;

    _classCallCheck(this, RemoteLogClient);

    _this = _super.call(this, config);
    var _config$formatMessage = config.formatMessage,
        formatMessage$1 = _config$formatMessage === void 0 ? formatMessage : _config$formatMessage;
    _this.formatMessage = formatMessage$1;
    return _this;
  }

  _createClass(RemoteLogClient, [{
    key: "createMessage",
    value: function createMessage(logLevel, context, marker, message) {
      for (var _len = arguments.length, args = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
        args[_key - 4] = arguments[_key];
      }

      return {
        logLevel: logLevel,
        marker: marker,
        message: this.formatMessage(marker, message, args, context)
      };
    }
  }]);

  return RemoteLogClient;
}(BaseRemoteLogClient);

var isObject = function isObject(value) {
  return _typeof(value) === 'object' && !Array.isArray(value);
};

var _createMessage = function createMessage(extractMessageContext, logLevel, context, marker, rawMessage, args) {
  var contextIsSpreadable = !context || isObject(context);

  var _ref = isError(rawMessage) ? {
    message: rawMessage.message,
    error: formatError(rawMessage)
  } : {
    message: rawMessage
  },
      message = _ref.message,
      error = _ref.error; // Speed up processing when no additional args.


  if (!args.length) {
    return {
      logLevel: logLevel,
      marker: marker,
      context: context,
      message: message,
      error: error
    };
  } // Speed up processing when single additional arg is an error.


  if (args.length === 1 && isError(args[0])) {
    var _errors = error ? [error] : [];

    _errors.push(formatError(args[0]));

    return {
      logLevel: logLevel,
      marker: marker,
      context: context,
      message: message,
      error: _errors.length === 1 ? _errors[0] : undefined,
      errors: _errors.length > 1 ? _errors : undefined
    };
  }

  var lastArg = args[args.length - 1];
  var additionalContext = extractMessageContext && contextIsSpreadable && isObject(lastArg) && !isError(lastArg) ? JSON.parse(stringify(lastArg)) : undefined;
  var errors = args.reduce(function (errs, arg) {
    if (isError(arg)) errs.push(formatError(arg));
    return errs;
  }, error ? [error] : []);
  var additionalArgs = (additionalContext ? args.slice(0, -1) : args).filter(function (arg) {
    return !isError(arg);
  }).map(function (arg) {
    return stringify(arg);
  });
  return {
    logLevel: logLevel,
    marker: marker,
    context: additionalContext ? _objectSpread2(_objectSpread2({}, context), additionalContext) : context,
    message: additionalArgs.length ? [message].concat(_toConsumableArray(additionalArgs)).join(' ') : message,
    error: errors.length === 1 ? errors[0] : undefined,
    errors: errors.length > 1 ? errors : undefined
  };
};

var RemoteLogJsonClient = /*#__PURE__*/function (_BaseRemoteLogClient) {
  _inherits(RemoteLogJsonClient, _BaseRemoteLogClient);

  var _super = _createSuper(RemoteLogJsonClient);

  function RemoteLogJsonClient(config) {
    var _this;

    _classCallCheck(this, RemoteLogJsonClient);

    _this = _super.call(this, config);
    _this.extractMessageContext = config.extractMessageContext || false;
    _this.contextMiddleware = config.contextMiddleware;
    return _this;
  }

  _createClass(RemoteLogJsonClient, [{
    key: "createMessage",
    value: function createMessage(logLevel, context, marker, message) {
      var modifiedContext = this.contextMiddleware ? this.contextMiddleware(context, marker) : context;

      for (var _len = arguments.length, args = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
        args[_key - 4] = arguments[_key];
      }

      return _createMessage(this.extractMessageContext, logLevel, modifiedContext, marker, message, args);
    }
  }]);

  return RemoteLogJsonClient;
}(BaseRemoteLogClient);

export default RemoteLogClient;
export { RemoteLogClient, RemoteLogJsonClient };
//# sourceMappingURL=index.js.map
